import { css } from '@emotion/core';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import CommitteeMembers from '@/src/committees/components/CommitteeMembers';
import Breadcrumbs from '@/src/shared/components/Breadcrumbs';
import Container from '@/src/shared/components/Container';
import Divider from '@/src/shared/components/Divider';
import Heading from '@/src/shared/components/Heading';
import Layout from '@/src/shared/components/Layout';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import { ABOUT_ACCESS } from '@/src/shared/constants';
import { bp, colors, space } from '@/styles';
import request from '@/utils/axios';

const style = {
  section: css`
    padding-bottom: 200px !important;
    @media ${bp.md} {
      padding-bottom: 75px !important;
    }
  `,
  title: css`
    margin-bottom: 24px;
    @media print {
      font-size: 2.6rem;
      line-height: 3.2rem;
    }
  `,
  breadcrumbs: css`
    left: 0;
    margin-top: -32px !important;
    position: absolute;
    right: 0;
    width: 100%;
    z-index: 3;
  `,
  info: css`
    color: ${colors.secondaryGray};
    font-size: 1.6rem;
    margin-top: -24px !important;
  `,
  contactUs: css`
    font-weight: 800;
    color: ${colors.secondaryBlue};
  `,
  divider: css`
    @media print {
      display: none;
    }
  `,
};

const BoardOfDirectors = () => {
  const router = useRouter();

  const { route } = router;

  // const [CommitteeData, setCommitteeData] = useState([]);
  const [Officers, setOfficers] = useState([]);
  const [Members, setMembers] = useState([]);
  const enableBio = false;

  useEffect(() => {
    const fetchPageData = async () => {
      const response = await request({
        url: `profile/committeemembers`,
        params: {
          committeecode: 55,
        },
      });
      const { data } = response;
      const officers = data.filter(o => {
        return o.PositionCode === '1' || o.PositionCode === '722';
      });
      setOfficers(officers);
      const members = data.filter(m => {
        return m.PositionCode !== '1' && m.PositionCode !== '722';
      });
      setMembers(members);
      // setCommitteeData(data);
    };
    fetchPageData();
  }, []);

  const pageTitle = 'Board of Directors';

  return (
    <Layout>
      <Section css={style.section}>
        <Container css={[style.breadcrumbs]}>
          <Breadcrumbs theme="dark" />
          <Divider type="red" css={style.divider} />
          <Heading type={1} theme="jumbo" css={[style.title]}>
            {pageTitle}
          </Heading>
        </Container>
      </Section>
      <Section css={style.section}>
        <Container>
          <Heading type={3} weight="bold" theme="primaryGray" css={[space.m.t20, space.m.b20]}>
            Officers
          </Heading>
          <CommitteeMembers members={Officers} route={route} enableBio={enableBio} showPosition />
          <Heading type={3} weight="bold" theme="primaryGray" css={[space.m.t20, space.m.b20]}>
            Board Members
          </Heading>
          <CommitteeMembers
            members={Members}
            route={route}
            enableBio={enableBio}
            showPosition={false}
          />
        </Container>
      </Section>
      <WebLogImage title={pageTitle} path="/about/leadership/board-of-directors" />
    </Layout>
  );
};

/* export async function getStaticProps() {
  return { props: { sitepageid: 55567 } };
} */

export default connect(mapStateToProps)(
  withMembershipAccessWrap(BoardOfDirectors, ABOUT_ACCESS.BOARD_DIRECTORS, true)
);
